module.exports = __webpack_public_path__ + "img/customer_4_en.850f17c8.png";